import { debounce } from 'lodash';
import { Dispatch, useCallback, useReducer } from 'react';
import { GENERIC_REDUCER } from '@helpers/constants.tsx';
import { IPaginationParams } from '@helpers/types.ts';
import { GridCallbackDetails, GridPaginationModel } from '@mui/x-data-grid';

const initializerArg: IPaginationParams = {
  page: 0,
  sort: {
    created_at: -1,
  },
  search: {},
  page_size: 10,
};

interface IServerPaginationResult {
  filters: IPaginationParams;
  onPaginationModelChange: (
    page: GridPaginationModel,
    details: GridCallbackDetails,
  ) => void;
  resetFilters: () => void;
  onChangeFilter: (search: any) => void;
}

const useServerPagination = (): IServerPaginationResult => {
  const [filters, dispatch]: [
    IPaginationParams,
    Dispatch<Partial<IPaginationParams>>,
  ] = useReducer(GENERIC_REDUCER, initializerArg);

  const onPaginationModelChange = useCallback(
    (page: GridPaginationModel, _details: GridCallbackDetails) => {
      dispatch({ page: page.page, page_size: page.pageSize });
    },
    [],
  );

  const onChangeFilter = useCallback(
    debounce((search) => {
      dispatch({
        search: {
          ...filters.search,
          ...search,
        },
      });
    }, 600),
    [filters],
  );

  const resetFilters = useCallback(() => dispatch(initializerArg), []);
  return {
    filters,
    onPaginationModelChange,
    resetFilters,
    onChangeFilter,
  };
};

export default useServerPagination;
